import { HttpHeaders } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { newFeatures } from 'src/app/model/page/newly-added-features';
import { AddionalOffersData, SandboxPage } from 'src/app/model/page/sandbox-page';
import {
  AirlineOffersScreenRequest,
  FareGroup,
  FareList,
  Flight,
  OfferItem as airLineOfferRequestOfferItem,
  OrderItem,
  OriginDestination,
  Passenger as airLineOfferRequestPassenger,
  Preference
} from 'src/app/model/request/airline-offers-screen-request';
import { CabinPreferences, Passenger as searchFlightPassengers, SearchFlightsScreenRequest } from 'src/app/model/request/search-flights-screen-request';
import {
  AirlineFilter,
  AirlineOffer,
  AirlineOfferBase,
  AirlineOffersScreen,
  BoundAirlineOffer,
  FlightDetail,
  IconsStatus,
  OfferItems,
  OriginDestinationList,
  Passenger,
  PriceCalendarList,
  PriceDetail,
  Rule
} from 'src/app/model/screen/airline-offers-screen';
import { boundSlider, FilterOffersScreen } from 'src/app/model/screen/filter-offers-screen';
import { OfferPriceScreen } from 'src/app/model/screen/offer-price-screen';
import { DateFormatPipe } from 'src/app/pipe/date-format.pipe';
import { ApiService } from 'src/app/service/api.service';
import { CommonService } from 'src/app/service/common.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { LocalAssetReaderService } from 'src/app/service/local-asset-reader.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';
import searchFlightsJSON from 'src/assets/json/search-flights/request/search-flights-request-default-params.json';
import { config } from 'src/environments/environment';

import { documentToHtmlString } from '../../../model/shared/index-featureGuide';

declare function featureGuideSecond(): any;
declare function featureGuidejs(): any;
@Component({
  selector: 'app-airline-offers-screen',
  templateUrl: './airline-offers-screen.component.html',
  styleUrls: ['./airline-offers-screen.component.scss']
})
export class AirlineOffersScreenComponent implements OnInit, OnDestroy {
  sandboxPage: SandboxPage = {} as SandboxPage;
  newFeatures: newFeatures = {} as newFeatures;
  flightLogoMap = new Map();
  remarkText: string = '';
  baggagesIds: any[] = [];
  bags: any;
  @Input() selectedIndexno: number = 0;
  seletcedItemIndex: any;
  airlineOffersScreen: AirlineOffersScreen = {} as AirlineOffersScreen;
  filterOffersScreen: FilterOffersScreen = {} as FilterOffersScreen;
  sandboxPageStateServiceSubscription: any;
  airlineOffersScreenRequest: AirlineOffersScreenRequest = {} as AirlineOffersScreenRequest;
  public baCheckBag: boolean = true;

  airLineData: any;
  jsonObject: any;
  xml = '';
  public xmlItems: any;
  collapsedStatusRulesInboundArray: boolean[] = [];
  collapsedStatusRulesOutboundArray: boolean[] = [];
  toggleMap = new Map();
  toggle = { toggle: true, accordionClass: 'not-collapsed', arrowIconsClass: 'icon-arrowUp', activeClass: 'active' };
  collapsed = { toggle: false, accordionClass: 'collapsed', arrowIconsClass: 'icon-arrowDown', activeClass: 'title-hover' };
  public selectedIndex: any = '';
  public showRules: boolean = false;
  public segmentList: any = [];
  public segmentListIds: any = [];
  public flightList: any = [];
  public flightListIds: any = [];
  public priceClassList: any = [];
  public priceClassListIds: any = [];
  public fareList: any = [];
  public fareListIds: any = [];
  public descriptionList: any = [];
  public descriptionListIds: any = [];
  public rulesList: any = [];
  public rulesIds: any = [];
  public pNumberList: any = [];
  public lastPagination: number = 0;
  public beforeActivePage: number = 1;
  public afterActivePage: number = 1;
  public changeFeeInd: any;
  public refundableInd: any;
  public cancelFeeInd: any;
  displayResults: any[] = [];
  searchResults: any[] = [];
  public baggageList: any[] = [];
  public passengersList: Passenger[] = [];
  public infantRefsIds: any[] = [];
  public adultRefsIds: any[] = [];
  public priceCalendar: any[] = [];
  public originDestList: any[] = [];
  public priceCalendarMapArray: PriceCalendarList[] = [];
  addionaldetailsArray: any[] = [];
  public pSettings = {
    start: 0,
    length: 10
  };

  public airlineOfferScreenResponseId = '';

  public airlineFilterData: AirlineFilter = {
    airportList: [],
    operaterList: [],
    priceClassList: []
  };
  public mappedSelectedOfferPriceFareCode: any = [];
  airlineLogos: [] = [];

  searchFlightsScreenRequest: SearchFlightsScreenRequest = {} as SearchFlightsScreenRequest;
  public totPassenger: number = 1;
  inputParamsMap = new Map();
  formHaveInvalidFields: boolean = true;

  selectedDepartureDate: any;
  selectedArrivalDate: any;
  addionalOffersArray: AddionalOffersData[] = [];
  isUserVisitingSandBoxFirstTime: boolean = false;

  constructor(
    private localAssetReaderService: LocalAssetReaderService,
    private sandboxPageStateService: SandboxPageStateService,
    private apiService: ApiService,
    private datePipe: DateFormatPipe,
    private xmlToJsonParserService: XmlToJsonParserService,
    private contentfulService: ContentfulService,
    private commonService: CommonService
  ) {
    const query = { 'fields.name': 'Airline Logos#SANDBOX' };
    this.contentfulService.getMenuContentWithItems(query).then((items) => {
      this.airlineLogos = items[0]?.fields.jsonData;

      if (this.airlineLogos && Object.keys(this.airlineLogos).length > 0) {
        Object.entries(this.airlineLogos).forEach((entry) => {
          const [key, value] = entry;

          this.flightLogoMap.set(key, value);
        });
      }
    });

    {
      Object.entries(searchFlightsJSON).forEach((entry) => {
        const [key, value] = entry;
        this.inputParamsMap.set(key, value);
      });
    }
  }

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      // return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }

  ngOnInit(): void {
    const query = { 'fields.title': 'airline additional features' };
    this.contentfulService.getPageContentResponse(query).then((loginPageResponse) => {
      this.newFeatures.newfeatureSectionCard = [];
      this.newFeatures.sections = [];

      this.mapCards(loginPageResponse.includes.Entry);
      if (config.sandboxFeatureGuide && this.isUserVisitingSandBoxFirstTime) {
        featureGuideSecond();
        featureGuidejs();
      }
    });

    this.mapToAirlineOffersScreen();
    this.airlineOfferScreenResponseId = this.airlineOffersScreen.responseID;

    this.addionalOffersArray = this.sandboxPageStateService.getAddionalOffersData();

    if (this.addionalOffersArray && typeof this.addionalOffersArray[0] !== 'undefined' && typeof this.addionalOffersArray[0].seletcedItemIndex !== 'undefined') {
      this.seletcedItemIndex = this.addionalOffersArray[0].seletcedItemIndex;
    }
    this.isUserVisitingSandBoxFirstTime = this.commonService['checkForUsersFirstVisit']('timeDayFeature');
  }

  private featureGuideCard(entry: Entry<any>) {
    let headerImage: any = entry.fields['headImage'];
    this.newFeatures.newfeatureSectionCard.push({
      title: entry.fields['title'] as string,
      order: entry.fields['order'] as number,
      headImage: headerImage?.fields?.file?.url,
      richTextBody: entry.fields['body'] as string
    });
    this.newFeatures.newfeatureSectionCard.sort((a, b) => a.order - b.order);
  }

  private mapCards(newFeatursContentPageEntries: Entry<any>[]) {
    newFeatursContentPageEntries
      .filter((entry) => ModelValidator.isCard(entry))
      .forEach((entry) => {
        this.featureGuideCard(entry);
      });
  }

  updateGuideVisit(featureName: string) {
    localStorage.setItem(featureName, this.sandboxPageStateService.getEncodedUserId() + featureName);
  }

  getFlightLogoUrl(airlineName: string) {
    const flightLogoUrl = this.flightLogoMap.get(airlineName);
    if (flightLogoUrl) {
      return flightLogoUrl;
    }
    return '';
  }

  toggleCollapsedRulesInbound(index: number) {
    this.collapsedStatusRulesInboundArray[index] = !this.collapsedStatusRulesInboundArray[index];
  }

  toggleCollapsedRulesOutbound(index: number) {
    this.collapsedStatusRulesOutboundArray[index] = !this.collapsedStatusRulesOutboundArray[index];
  }

  async getSelectedOfferPrice(offerIndex: any) {
    let airLineOfferScreenData: AirlineOffersScreen = this.sandboxPageStateService.getAirlineOffersScreenData();
    let responseID = airLineOfferScreenData.responseID;
    let selectedOffer = airLineOfferScreenData.airlineOffers[offerIndex];
    this.initAirlineOffersScreenRequest(selectedOffer, responseID);
  }

  async initAirlineOffersScreenRequest(selectedOffer: AirlineOffer, responseID: string) {
    let searchFlightFormValue = this.sandboxPageStateService.getSearchFlightFormValue();
    let isShortSell = searchFlightFormValue.shortSell;
    let boundOffers = selectedOffer.boundAirlineOffer;
    const searchFlightJSONRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.SEARCH_FLIGHTS_SCREEN_URL);
    const searchFlightsScreenRequest: SearchFlightsScreenRequest = JSON.parse(searchFlightJSONRequest);
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.AIRLINE_OFFER_TEMPLATE);
    this.airlineOffersScreenRequest = JSON.parse(jsonRequestTemplate as any);
    this.airlineOffersScreenRequest['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.airlineOffersScreenRequest['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.airlineOffersScreenRequest['S:Envelope']['SOAP-ENV:Header'] = '';
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.$.Version = '17.2';
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Document = searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Document;
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Party = searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Party;
    if (isShortSell) {
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Query.Offer = {
        $: {
          OfferID: selectedOffer.offerId,
          Owner: selectedOffer.offerOwner,
          ResponseID: responseID
        },
        OfferItem: this.mapOfferPriceScreenQuery(selectedOffer.offerItem)
      };
    } else {
      delete this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Query.Offer;
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Query.OrderItem = {} as OrderItem;
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Query.OrderItem.OfferItemID = {
        $: {
          Owner: selectedOffer.offerOwner
        },
        _: 'Offer1'
      };
      if (isShortSell) {
        this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Query.OrderItem.OfferItemType = {
          DetailedFlightItem: {
            OriginDestination: this.loadOfferPriceRequestOrigin(boundOffers)
          }
        };
      } else {
        this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Query.OrderItem.OfferItemType = {
          DetailedFlightItem: {
            OriginDestination: this.loadOfferPriceRequestOriginLongsell(boundOffers)
          }
        };
      }
    }

    if (searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference['FarePreferences'] === undefined) {
      let farePreferences = {} as Preference;
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Preference = farePreferences;
    } else {
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.Preference.FarePreferences!.Types =
        searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference.FarePreferences!.Types;
    }
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.DataLists.PassengerList.Passenger = [];
    this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.DataLists.PassengerList.Passenger = this.getSearchAirlinepassenger();
    if (!isShortSell) {
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.DataLists.FareList = {} as FareList;
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.DataLists.FareList.FareGroup = [];
      this.airlineOffersScreenRequest['S:Envelope']['S:Body']!.OfferPriceRQ.DataLists.FareList.FareGroup = this.loadFareGroup(boundOffers);
    }
    await this.apiService.getXMLResponse(this.sandboxPageStateService.AIRLINE_OFFERS_SCREEN_URL, JSON.stringify(this.airlineOffersScreenRequest), new Map(), {
      headers: new HttpHeaders({
        soapAction: 'OfferPrice17_2_V2'
      }),
      responseType: 'text'
    });
    this.updateOfferPriceScreenXML(this.sandboxPageStateService.AIRLINE_OFFERS_SCREEN_URL, selectedOffer);
  }
  loadOfferPriceRequestOrigin(boundOffers: BoundAirlineOffer[]) {
    let originDestination: OriginDestination[] = [];
    let boundOffersLength = boundOffers.length;
    if (boundOffersLength > 0) {
      let flightsDetail: Flight[] = [];
      boundOffers.forEach((boundOffer: BoundAirlineOffer) => {
        boundOffer.flightDetails.forEach((flightDetail: FlightDetail) => {
          let flightMapResult = this.mapOfferRequestFlightDetail(flightDetail);
          flightsDetail.push(flightMapResult);
        });
      });
      originDestination.push({
        Flight: flightsDetail
      });
    }
    return originDestination;
  }
  loadOfferPriceRequestOriginLongsell(boundOffers: BoundAirlineOffer[]) {
    let originDestination: OriginDestination[] = [];
    let boundOffersLength = boundOffers.length;
    if (boundOffersLength > 0) {
      boundOffers.forEach((boundOffer: BoundAirlineOffer) => {
        let flightsDetail: Flight[] = [];
        boundOffer.flightDetails.forEach((flightDetail: FlightDetail) => {
          let flightMapResult = this.mapOfferRequestFlightDetail(flightDetail);
          flightsDetail.push(flightMapResult);
        });
        originDestination.push({
          Flight: flightsDetail
        });
      });
    }
    return originDestination;
  }
  mapOfferRequestFlightDetail(flightDetail: FlightDetail) {
    let mapFlightDetail: Flight = {
      Departure: {
        AirportCode: flightDetail.departureAirportCode,
        Date: flightDetail.actualDepatureDate,
        Time: flightDetail.departureTimeIn24H
      },
      Arrival: {
        AirportCode: flightDetail.arrivalAirportCode,
        Date: flightDetail.actualArrivalDate
      },
      MarketingCarrier: {
        AirlineID: flightDetail.airlineId,
        FlightNumber: flightDetail.airlineNumber
      },
      ClassOfService: {
        $: {
          refs: flightDetail.fbcode
        },
        Code: flightDetail.flightType
      }
    };
    return mapFlightDetail;
  }
  loadFareGroup(boundOffers: BoundAirlineOffer[]) {
    this.mappedSelectedOfferPriceFareCode = [];
    let boundOffersLength = boundOffers.length;
    let fareGroup: FareGroup[] = [];
    if (boundOffersLength > 0) {
      boundOffers.forEach((boundOffer: BoundAirlineOffer) => {
        boundOffer.flightDetails.forEach((flightDetail: FlightDetail) => {
          let fareGroupMapResult = this.mapFareGroup(flightDetail);
          if (fareGroupMapResult.isMapped) {
            fareGroup.push(fareGroupMapResult.fareGroup);
          }
        });
      });
    }
    return fareGroup;
  }
  mapFareGroup(flightDetail: FlightDetail) {
    let isCodeMapped: any = this.mappedSelectedOfferPriceFareCode.indexOf(flightDetail.fbcode);

    let fareFroupData = { isMapped: false, fareGroup: {} as FareGroup };
    if (isCodeMapped === -1) {
      this.mappedSelectedOfferPriceFareCode.push(flightDetail.fbcode);
      let fareGroup: FareGroup = {
        $: {
          ListKey: flightDetail.fbcode
        },
        Fare: {
          FareCode: flightDetail.flightCode2
        },
        FareBasisCode: {
          Code: flightDetail.flightCode1
        }
      };
      fareFroupData.isMapped = true;
      fareFroupData.fareGroup = fareGroup;
    }
    return fareFroupData;
  }
  getSearchAirlinepassenger() {
    let airLineOfferScreenData: AirlineOffersScreen = this.sandboxPageStateService.getAirlineOffersScreenData();
    let passengerList = airLineOfferScreenData.passengerList;
    let infantRefsids = airLineOfferScreenData.infantRefsIds;
    let passengerLength = passengerList.length;
    let passengersDetail: airLineOfferRequestPassenger[] = [];
    if (passengerLength > 0) {
      let i = 0;
      passengerList.forEach((passenger: Passenger) => {
        let passengerDetail: airLineOfferRequestPassenger = {
          $: {
            PassengerID: passenger.passengerId
          },
          PTC: passenger.passengerType,
          Birthdate: passenger.passengerDOB,
          ResidenceCountryCode: this.sandboxPageStateService.getAgentResidenceCountryCode(),
          CitizenshipCountryCode: this.sandboxPageStateService.getCitizenshipCountryCode()
        };
        if (typeof infantRefsids[i] !== 'undefined' && passengerDetail.PTC === 'ADT') {
          passengerDetail.InfantRef = infantRefsids[i];
        }
        passengersDetail.push(passengerDetail);
        i++;
      });
    }
    return passengersDetail;
  }

  mapOfferPriceScreenQuery(offerItem: OfferItems[]) {
    let offerItemsList: airLineOfferRequestOfferItem[] = [];
    offerItem.forEach((offer: any) => {
      let offerItemList: airLineOfferRequestOfferItem = {
        $: {
          OfferItemID: offer.offerItemID
        },
        PassengerRefs: offer.passengerRefs
      };
      offerItemsList.push(offerItemList);
    });
    return offerItemsList;
  }

  updateOfferPriceScreenXML(url: string, selectedOffer: AirlineOffer) {
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      let patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let offerPriceScreen: OfferPriceScreen = {} as OfferPriceScreen;
      offerPriceScreen.isMapped = false;
      offerPriceScreen.selectedBagOfferItem = {
        offerId: '',
        owner: '',
        responseId: '',
        offerDetail: []
      };
      offerPriceScreen.selectedSeatItem = [];

      offerPriceScreen.xml = this.sandboxPageStateService.getResponseFromMap(url);
      offerPriceScreen.jsonData = this.xmlToJsonParserService.parseXMLToJSON(offerPriceScreen.xml!);

      let pricedOffer = offerPriceScreen.jsonData?.['SOAP:ENVELOPE']?.['SOAP:BODY']?.[0]?.OFFERPRICERS?.[0]?.PRICEDOFFER?.[0];
      let pricedOfferId = pricedOffer?.$?.OFFERID || '';

      if (selectedOffer.offerId != pricedOfferId) {
        let offerItemIDs = pricedOffer?.OFFERITEM?.map((item: any) => item.$.OFFERITEMID) || [];
        let selectedOfferItems = offerItemIDs.map((offerItemID: any, index: number) => {
          let passengerRefs = pricedOffer?.OFFERITEM?.[index]?.SERVICE?.[0]?.PASSENGERREFS[0];
          return {
            offerItemID: offerItemID,
            passengerRefs: passengerRefs
          };
        });
        offerPriceScreen.selectedOfferId = pricedOffer?.$?.OFFERID || '';
        offerPriceScreen.selectedOfferOwner = pricedOffer?.$?.OWNER || '';
        offerPriceScreen.selectedOfferItem = selectedOfferItems;
      } else {
        offerPriceScreen.selectedOfferId = selectedOffer.offerId;
        offerPriceScreen.selectedOfferOwner = selectedOffer.offerOwner;
        offerPriceScreen.selectedOfferItem = selectedOffer.offerItem;
      }

      this.sandboxPageStateService.updateOfferPriceScreenData(offerPriceScreen);
      let patchSandboxSourceData = { mainMenu: 'offer-price', sideMenu: 'none' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  mapToAirlineOffersScreen(): any {
    this.airlineOffersScreen.airlineOffers = [];
    let airlineOffers: AirlineOffer[] = this.sandboxPageStateService.getAirlineOffersScreenData().airlineOffers;
    if (airlineOffers.length > 0) {
      this.filterOffer(airlineOffers);
    } else {
      this.airlineFilterData.airportList = [];
      this.airlineFilterData.operaterList = [];
      this.airlineFilterData.priceClassList = [];

      let airlineOffersJSON: any = this.sandboxPageStateService.getAirlineOffersScreenData().jsonData;

      if (airlineOffersJSON) {
        let seatEnvelop = airlineOffersJSON['SOAP:ENVELOPE'];
        let seatBody = seatEnvelop['SOAP:BODY'][0];
        let airShoppings = seatBody['AIRSHOPPINGRS'][0];
        this.airlineOffersScreen.responseID = airShoppings.SHOPPINGRESPONSEID[0].RESPONSEID;
        this.airlineOfferScreenResponseId = airShoppings.SHOPPINGRESPONSEID[0].RESPONSEID;
        let flightOffers = airShoppings['OFFERSGROUP'][0]['AIRLINEOFFERS'][0]['OFFER'];
        let dataList = airShoppings['DATALISTS'][0];
        this.originDestList = dataList.ORIGINDESTINATIONLIST[0].ORIGINDESTINATION;
        this.segmentList = dataList['FLIGHTLIST'][0]['FLIGHT'];
        let flightDetail = dataList['FLIGHTSEGMENTLIST'][0];
        this.flightList = flightDetail['FLIGHTSEGMENT'];
        this.priceClassList = dataList['PRICECLASSLIST'][0]['PRICECLASS'];
        this.fareList = dataList['FARELIST'][0]['FAREGROUP'];
        this.baggageList = dataList['BAGGAGEALLOWANCELIST'][0]['BAGGAGEALLOWANCE'];
        this.descriptionList = dataList['DESCRIPTIONLIST'][0]['DESCRIPTION'];

        let priceCalRef = airShoppings.OFFERSGROUP[0].AIRLINEOFFERS[0];

        if (priceCalRef.PRICECALENDAR) {
          this.priceCalendar = airShoppings.OFFERSGROUP[0].AIRLINEOFFERS[0].PRICECALENDAR;

          this.mapPriceCalendar(this.priceCalendar);
        }

        if (typeof dataList['PENALTYLIST'] !== 'undefined') {
          this.rulesList = dataList['PENALTYLIST'][0]['PENALTY'];
          this.mapRulesIds(this.rulesList);
        }
        this.mapPassenger(dataList['PASSENGERLIST'][0]['PASSENGER']);
        this.mapBaggageIds(this.baggageList);
        this.mapDescription(this.descriptionList);
        this.mapFareIds(this.fareList);
        this.mapPriceIds(this.priceClassList);
        this.mapFlightId(this.flightList);
        this.mapFlightSegmentIds(this.segmentList);
        this.mapAirlineOffers(flightOffers);
      } else {
        // console.log('this.sandboxPageStateService.getAirlineOffersScreenData().jsonData is undefined');
      }
    }
  }

  mapPassenger(passengerList: any) {
    this.passengersList = [];
    let passengerLength = passengerList.length;
    if (passengerLength > 0) {
      passengerList.forEach((passenger: any) => {
        let passengerDetail: Passenger = {
          passengerType: passenger.PTC[0],
          passengerId: passenger.$.PASSENGERID,
          passengerDOB: passenger.BIRTHDATE[0]
        };
        this.passengersList.push(passengerDetail);
        if (passenger.PTC[0] === 'INF') {
          this.infantRefsIds.push(passengerDetail.passengerId);
        } else if (passenger.PTC[0] === 'ADT') {
          this.adultRefsIds.push(passengerDetail.passengerId);
        }
      });
    }
  }

  mapRulesIds(rulesList: any) {
    this.rulesIds = [];
    let len = rulesList.length;
    if (len > 0) {
      rulesList.forEach((rule: any) => {
        this.rulesIds.push(rule.$.OBJECTKEY);
      });
    }
  }

  filterOffer(airlineOffers: AirlineOffer[]) {
    let numberofAirlineOffers = airlineOffers.length;
    if (numberofAirlineOffers > 0) {
      airlineOffers.forEach((airlineOffer: any) => {
        let boundOfferResult: boolean = true;
        let boundAirlineIndex = 0;
        airlineOffer.boundAirlineOffer.forEach((boundAirlineOffer: BoundAirlineOffer) => {
          if (boundOfferResult) {
            let boundFlight: any = boundAirlineOffer.flightDetails;
            let boundFlightLen = boundFlight.length;
            let boundFlightResult = this.customFilter(boundFlight, boundAirlineIndex);
            if (boundFlightResult) {
              boundOfferResult = boundFlightResult;
            } else {
              boundOfferResult = false;
            }
            boundAirlineIndex++;
          }
        });
        if (boundOfferResult) {
          this.airlineOffersScreen.airlineOffers.push(airlineOffer);
        }
      });
    }
  }

  customFilter(airlineOfferFightDetail: any, boundAirlineIndex: any): boolean {
    let filterOffersScreen: FilterOffersScreen = this.sandboxPageStateService.getFilterOffersScreenData();
    let selAirports = filterOffersScreen.airportList;
    let selPriceClass = filterOffersScreen.priceClassList;
    let selOperater = filterOffersScreen.operaterList;
    let sliderStartTime: any = '';
    let selSliderDetail = filterOffersScreen.boundSliders;
    let sliderEndTime: any = '';
    if (typeof selSliderDetail[boundAirlineIndex] !== 'undefined') {
      if (typeof selSliderDetail[boundAirlineIndex].startTime !== 'undefined') {
        sliderStartTime = this.convertTime(selSliderDetail[boundAirlineIndex].startTime);
      }
      if (typeof selSliderDetail[boundAirlineIndex].endTime !== 'undefined') {
        sliderEndTime = this.convertTime(selSliderDetail[boundAirlineIndex].endTime);
      }
    }
    let res = true;
    airlineOfferFightDetail.forEach((y: any, flightIndex: any) => {
      if (res) {
        if (res) {
          let isSelectedAirport: any = selAirports.indexOf(y.departureAirportCode);
          if (isSelectedAirport === -1) {
            res = false;
          }
        }
        if (res) {
          let isSelectedAirport: any = selAirports.indexOf(y.arrivalAirportCode);
          if (isSelectedAirport === -1) {
            res = false;
          }
        }
        if (res) {
          let isSelectedOperater: any = selOperater.indexOf(y.opperatingCarrierName);
          if (isSelectedOperater === -1) {
            res = false;
          }
        }
        if (res) {
          let isSelectedPriceClass: any = selPriceClass.indexOf(y.economyType);
          if (isSelectedPriceClass === -1) {
            res = false;
          }
        }
        if (flightIndex === 0 && sliderStartTime !== '' && res) {
          if (y.departureTimeIn24H < sliderStartTime || y.departureTimeIn24H > sliderEndTime) {
            res = false;
          }
        }
      }
    });
    return res;
  }

  mapDescription(descriptionList: any) {
    this.descriptionListIds = [];
    if (descriptionList.length > 0) {
      descriptionList.forEach((description: any) => {
        this.descriptionListIds.push(description.$.OBJECTKEY);
      });
    }
  }

  mapFareIds(fareList: any) {
    this.fareListIds = [];
    if (fareList.length > 0) {
      fareList.forEach((fare: any) => {
        this.fareListIds.push(fare.$.LISTKEY);
      });
    }
  }

  mapFlightId(flightList: any) {
    this.flightListIds = [];
    if (flightList.length > 0) {
      flightList.forEach((flight: any) => {
        let flightName = flight.$.SEGMENTKEY;
        this.flightListIds.push(flightName);
      });
    }
  }

  mapPriceIds(priceList: any) {
    this.priceClassListIds = [];
    if (priceList.length > 0) {
      priceList.forEach((price: any) => {
        let flightNumber: any = {};
        flightNumber['id'] = [];
        price.CLASSOFSERVICE.forEach((priceClass: any) => {
          let ref = priceClass.$.REFS.split(' ')[0];
          flightNumber['id'].push(ref);
        });
        this.priceClassListIds.push(flightNumber);
      });
    }
  }

  mapFlightSegmentIds(flightSegmentList: any) {
    this.segmentListIds = [];
    if (flightSegmentList.length > 0) {
      flightSegmentList.forEach((flightSegment: any) => {
        this.segmentListIds.push(flightSegment.$.FLIGHTKEY);
      });
    }
  }

  mapBaggageIds(baggageList: any) {
    this.baggagesIds = [];
    if (baggageList.length > 0) {
      baggageList.forEach((baggageIds: any) => {
        this.baggagesIds.push(baggageIds.$.BAGGAGEALLOWANCEID);
      });
    }
  }

  mapPriceCalendar(pricalArray: any) {
    this.priceCalendarMapArray = [];
    if (pricalArray.length > 0) {
      pricalArray.forEach((data: any) => {
        let priCallist = {} as PriceCalendarList;
        priCallist.priceDetails = [];
        data.PRICECALENDARDATE.forEach((dateDate: any) => {
          let odList = this.mapOriginDestinarion(this.originDestList, dateDate.$.ORIGINDESTINATIONREFERENCE);

          priCallist.priceDetails.push({
            originDestCode: dateDate.$.ORIGINDESTINATIONREFERENCE,
            departureCode: odList.departureCode,
            arrivalCode: odList.arrivalCode
          });
        });
        priCallist.currencyCode = data.TOTALPRICE[0].$.CODE;
        priCallist.totalPrice = data.TOTALPRICE[0]._;

        if (typeof data.PRICECALENDARDATE[0] !== 'undefined') {
          priCallist.fromDate = data.PRICECALENDARDATE[0]._;
        }
        if (typeof data.PRICECALENDARDATE[1] !== 'undefined') {
          priCallist.toDate = data.PRICECALENDARDATE[1]._;
        }
        this.priceCalendarMapArray.push(priCallist);

        let addionalOffersData = {} as AddionalOffersData;
        addionalOffersData.fromDate = priCallist.fromDate;
        addionalOffersData.toDate = priCallist.toDate;
        addionalOffersData.totalPrice = priCallist.totalPrice;
        addionalOffersData.currencyCode = priCallist.currencyCode;
        this.addionaldetailsArray.push(addionalOffersData);
      });
      this.sandboxPageStateService.updateAddionalOffersData(this.addionaldetailsArray);
    }
  }

  mapOriginDestinarion(oriDestiList: any, ODKey: any) {
    let ODList = {} as OriginDestinationList;
    oriDestiList.forEach((data: any) => {
      if (ODKey === data.$.ORIGINDESTINATIONKEY) {
        ODList = { arrivalCode: data.ARRIVALCODE[0], departureCode: data.DEPARTURECODE[0] };
      }
    });
    return ODList;
  }

  mapAirlineOffers(flightOffers: any) {
    if (flightOffers.length > 0) {
      let offerIndex = 0;
      flightOffers.forEach((flightOffer: any) => {
        const priceDetail = this.getPriceDetail(flightOffer);
        let fareDetail = flightOffer.OFFERITEM[0].FAREDETAIL[0].FARECOMPONENT;
        let offerItem = flightOffer.OFFERITEM[0];
        let serviceList = offerItem.SERVICE;
        let boundAirlineOfferDetail: BoundAirlineOffer[] = [];
        let serviceIndex: any = 0;
        serviceList.forEach((service: any) => {
          let flightRef = service.FLIGHTREFS[0];
          boundAirlineOfferDetail.push(this.getAirlineOfferBase(fareDetail, serviceIndex, flightRef, flightOffers));
          serviceIndex++;
        });
        let offerItemsList = flightOffer.OFFERITEM;
        let offerItemLength = offerItemsList.length;
        let offerItems: OfferItems[] = [];
        if (offerItemLength > 0) {
          offerItemsList.forEach((offerItemList: any) => {
            let offerItem: OfferItems = {
              offerItemID: offerItemList.$.OFFERITEMID,
              passengerRefs: ''
            };
            let offerItemService = offerItemList.SERVICE;
            let offerItemServiceLength = offerItemService.length;
            if (offerItemServiceLength > 0) {
              offerItemService.forEach((itemService: any) => {
                offerItem.passengerRefs = itemService.PASSENGERREFS[0];
              });
            }
            offerItems.push(offerItem);
          });
        }
        let airlineOffer: AirlineOffer = {
          offerIndex: offerIndex,
          offerOwner: flightOffer.$.OWNER,
          offerId: flightOffer.$.OFFERID,
          offerItem: offerItems,
          boundAirlineOffer: boundAirlineOfferDetail,
          priceDetail: priceDetail
        };
        this.airlineOffersScreen.airlineOffers.push(airlineOffer);
        offerIndex++;
      });
      let airlineScreenData = {
        airlineFilterData: this.airlineFilterData,
        airlineScreenResponseId: this.airlineOfferScreenResponseId,
        airlineScreenRequestPassengerList: this.passengersList,
        airlineScreenRequestInfantRefIds: this.infantRefsIds,
        airlineScreenRequestAdultsRefIds: this.adultRefsIds
      };

      this.airlineOffersScreen.airlineFilterData = airlineScreenData.airlineFilterData;
      this.airlineOffersScreen.responseID = airlineScreenData.airlineScreenResponseId;
      this.airlineOffersScreen.passengerList = airlineScreenData.airlineScreenRequestPassengerList;
      this.airlineOffersScreen.infantRefsIds = airlineScreenData.airlineScreenRequestInfantRefIds;
      this.airlineOffersScreen.adultRefsIds = airlineScreenData.airlineScreenRequestAdultsRefIds;
      let filterScreenData = this.sandboxPageStateService.getFilterOffersScreenData();
      this.filterOffersScreen = {
        airportList: airlineScreenData.airlineFilterData.airportList,
        priceClassList: airlineScreenData.airlineFilterData.priceClassList,
        operaterList: airlineScreenData.airlineFilterData.operaterList,
        boundSliders: filterScreenData.boundSliders
      };
      this.sandboxPageStateService.updateAirlineOffersScreenData(this.airlineOffersScreen);
      this.sandboxPageStateService.updateFilterOffersScreenData(this.filterOffersScreen);
      let patchSandboxSourceData = { sideMenu: 'filterOffer', disableOfferFilter: false, sandboxScreen: 'airline-offers-screen' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  roundOffAirlinePriceDetails(value: string): string {
    let priceData = parseFloat(value);
    return priceData.toFixed(2);
  }
  getPriceDetail(flightOffer: any): PriceDetail {
    let descriptionType = flightOffer.DESCRIPTIONREFERENCES[0];
    let descriptionIndex: any = this.descriptionListIds.indexOf(descriptionType);
    let selDescription = this.descriptionList[descriptionIndex];
    let price$ = flightOffer.TOTALPRICE[0].SIMPLECURRENCYPRICE[0];
    let priceDetail: PriceDetail = {
      negotiationStatus: selDescription.TEXT[0],
      price: price$._,
      currency: price$.$.CODE
    };
    return priceDetail;
  }

  getAirlineOfferBase(fareDetail: any, index: number, flightRef: any, flightOffers: any): AirlineOfferBase {
    let rules: Rule[] = [];
    let flightDetails: FlightDetail[] = [];
    let rulesArray = [];
    if (typeof fareDetail[index].FARERULES !== 'undefined') {
      rulesArray = fareDetail[index].FARERULES[0].PENALTY[0].$.REFS.split(' ');
    }

    if (rulesArray.length > 0) {
      rulesArray?.forEach((rule: any) => {
        let rulexIndex: any = this.rulesIds.indexOf(rule);
        if (typeof this.rulesList[rulexIndex] !== 'undefined') {
          let selRow = this.rulesList[rulexIndex];
          if (selRow.APPLICABLEFEEREMARKS) {
            let rulesList: Rule = {
              remark: selRow.APPLICABLEFEEREMARKS[0].REMARK[0],
              label: selRow?.DETAILS[0]?.DETAIL[0]?.TYPE[0],
              changeFeeInd: selRow?.$?.CHANGEFEEIND,
              refundableInd: selRow?.$?.REFUNDABLEIND,
              cancelFeeInd: selRow?.$?.CANCELFEEIND
            };
            rules.push(rulesList);
            if (rules[0].label === 'CANCELLATION') {
              this.changeFeeInd = rules[1]?.changeFeeInd;
              this.refundableInd = rules[0]?.refundableInd;
              this.cancelFeeInd = rules[0]?.cancelFeeInd;
              this.remarkText = rules[1]?.remark;
            } else {
              this.changeFeeInd = rules[0].changeFeeInd;
              this.refundableInd = rules[1]?.refundableInd;
              this.cancelFeeInd = rules[1]?.cancelFeeInd;
              this.remarkText = rules[0]?.remark;
            }
          } else {
            let rulesList: Rule = {
              remark: selRow.DETAILS[0]?.DETAIL[0].AMOUNTS[0].AMOUNT[0].APPLICABLEFEEREMARKS[0].REMARK[0],
              label: selRow?.DETAILS[0]?.DETAIL[0]?.TYPE[0],
              changeFeeInd: selRow?.$?.CHANGEFEEIND,
              refundableInd: selRow?.$?.REFUNDABLEIND,
              cancelFeeInd: selRow?.$?.CANCELFEEIND
            };
            rules.push(rulesList);
            if (rules[0].label === 'CANCELLATION') {
              this.changeFeeInd = rules[1]?.changeFeeInd;
              this.refundableInd = rules[0]?.refundableInd;
              this.cancelFeeInd = rules[0]?.cancelFeeInd;
              this.remarkText = rules[1]?.remark;
            } else {
              this.changeFeeInd = rules[0]?.changeFeeInd;
              this.refundableInd = rules[1]?.refundableInd;
              this.cancelFeeInd = rules[1]?.cancelFeeInd;
              this.remarkText = rules[0]?.remark;
            }
          }
        }
      });
    }
    flightOffers.forEach((flightOffer: any) => {
      let baggeRef = flightOffer.BAGGAGEALLOWANCE[0].BAGGAGEALLOWANCEREF[0];
      let baggageIndex = this.baggagesIds.indexOf(baggeRef);
      this.bags = this.baggageList[baggageIndex];
      let quantity = '0';

      if (typeof this.bags.PIECEALLOWANCE !== 'undefined') {
        quantity = this.bags.PIECEALLOWANCE[0].TOTALQUANTITY[0];
        if (quantity === '0') {
          this.baCheckBag = false;
        }
      }
    });

    let segmentIndex: any = this.segmentListIds.indexOf(flightRef);
    let selRow = this.segmentList[segmentIndex];
    let flightIdss = selRow.SEGMENTREFERENCES[0];
    let flightArr = flightIdss.split(' ');
    let flightLen = flightArr.length;
    if (flightLen > 0) {
      flightArr.forEach((flight: any) => {
        const flightDetail = this.getFlightDetail(fareDetail, index, flight);
        flightDetails.push(flightDetail);
      });
    }
    return {
      rules: rules,
      flightDetails: flightDetails,
      displayRule: false
    };
  }

  getFlightDetail(fareDetail: any, index: number, flight: any): FlightDetail {
    let flightNumber = flight;
    let upPriceClassRef = fareDetail[index].PRICECLASSREF[0];
    let upPriceClassRefArr = upPriceClassRef.split('_');
    let priceClassIndex = upPriceClassRefArr[1] - 1;
    let priceClassFlightsArr = this.priceClassListIds[priceClassIndex]['id'];
    let priceClassFlightIndex: any = priceClassFlightsArr.indexOf(flightNumber);
    let priceClassDetail = this.priceClassList[priceClassIndex];
    let priceClassServiceArr = priceClassDetail.CLASSOFSERVICE;
    let priceClassServiceSelRow = priceClassServiceArr[priceClassFlightIndex];
    let fbCode = priceClassServiceSelRow.$.REFS.split(' ')[1];
    let fbCodeIndex: any = this.fareListIds.indexOf(fbCode);
    let selFareRow = this.fareList[fbCodeIndex];
    let flightIndex: any = this.flightListIds.indexOf(flightNumber);
    let selRow = this.flightList[flightIndex];
    let iconsStatus: IconsStatus = {
      baChangesFee: this.changeFeeInd,
      baRefund: this.refundableInd,
      baHandBag: true,
      baCheckBag: this.baCheckBag,
      cancelFee: this.cancelFeeInd,
      remark: this.remarkText
    };
    //airLineFilterData
    let depatureDetail = selRow.DEPARTURE[0];
    let arrivalDetail = selRow.ARRIVAL[0];
    let marketingCarrier = selRow.MARKETINGCARRIER[0];
    let operatingCarrier = selRow.OPERATINGCARRIER[0];
    let fDetail = selRow.FLIGHTDETAIL[0];
    let fDuriation = fDetail.FLIGHTDURATION[0].VALUE[0];
    let flightDetail: FlightDetail = {
      opperatingCarrierName: operatingCarrier.NAME[0],
      departureDate: this.datePipe.transform(depatureDetail.DATE[0], 'dd-MMM'),
      departureTimeIn24H: depatureDetail.TIME[0],
      departureAirportName: depatureDetail.AIRPORTNAME[0],
      departureAirportCode: depatureDetail.AIRPORTCODE[0],
      arrivalDate: this.datePipe.transform(arrivalDetail.DATE[0], 'dd-MMM'),
      arrivalTimeIn24H: arrivalDetail.TIME[0],
      arrivalAirportName: arrivalDetail.AIRPORTNAME[0],
      arrivalAirportCode: arrivalDetail.AIRPORTCODE[0],
      airlineId: marketingCarrier.AIRLINEID[0],
      airlineNumber: marketingCarrier.FLIGHTNUMBER[0],
      airlineName: marketingCarrier.NAME[0],
      duriation: fDuriation.slice(2),
      economyType: priceClassDetail.NAME[0],
      marketingName: priceClassDetail.CLASSOFSERVICE[0].MARKETINGNAME[0]._,
      flightType: priceClassServiceSelRow.CODE[0]._,
      flightCode1: selFareRow.FAREBASISCODE[0].CODE[0],
      flightCode2: selFareRow.FARE[0].FARECODE[0],
      iconsStatus: iconsStatus,
      fbcode: fbCode,
      actualDepatureDate: depatureDetail.DATE[0],
      actualArrivalDate: arrivalDetail.DATE[0]
    };
    let availableAirCodeList: any = this.airlineFilterData.airportList;
    if (availableAirCodeList.indexOf(arrivalDetail.AIRPORTCODE[0]) === -1) {
      this.airlineFilterData.airportList.push(arrivalDetail.AIRPORTCODE[0]);
    }
    if (availableAirCodeList.indexOf(depatureDetail.AIRPORTCODE[0]) === -1) {
      this.airlineFilterData.airportList.push(depatureDetail.AIRPORTCODE[0]);
    }
    let availableOperaterList: any = this.airlineFilterData.operaterList;
    if (availableOperaterList.indexOf(operatingCarrier.NAME[0]) === -1) {
      this.airlineFilterData.operaterList.push(operatingCarrier.NAME[0]);
    }
    let availablePriceClassList: any = this.airlineFilterData.priceClassList;
    if (availablePriceClassList.indexOf(priceClassDetail.NAME[0]) === -1) {
      this.airlineFilterData.priceClassList.push(priceClassDetail.NAME[0]);
    }

    return flightDetail;
  }

  getRemark(airlineOfferBase: AirlineOfferBase, index: number): string {
    return airlineOfferBase.rules[index].remark;
  }

  public toggleRules(airLineIndex: number, boundIndex: any) {
    let selRow = this.airlineOffersScreen.airlineOffers[airLineIndex];

    let isDisplay: boolean = false;
    isDisplay = this.airlineOffersScreen.airlineOffers[airLineIndex].boundAirlineOffer[boundIndex].displayRule;
    let toggleStatus: boolean = false;
    if (!isDisplay) {
      toggleStatus = true;
    } else {
      toggleStatus = false;
    }
    this.airlineOffersScreen.airlineOffers[airLineIndex].boundAirlineOffer[boundIndex].displayRule = toggleStatus;
  }

  getFilter() {
    this.pNumberList = [];
    this.displayResults = [];
    let airlineOffers = this.airlineOffersScreen.airlineOffers;
    let numberOfAirlineOffers = airlineOffers.length;

    let startIndex = this.pSettings.start;
    let perPage = this.pSettings.length;
    let totBtn = numberOfAirlineOffers / perPage;
    if (totBtn % 1 != 0) {
      totBtn = Math.round(totBtn);
    }
    let btnStart: any = 0;
    let btnEnd: any = 0;
    if (startIndex == 0) {
      btnEnd = this.afterActivePage + 2;
    } else {
      btnStart = startIndex - this.beforeActivePage;
      btnEnd = startIndex + this.afterActivePage + 1;
    }
    if (btnEnd >= totBtn) {
      btnStart = totBtn - 3;
      btnEnd = totBtn;
    }
    if (totBtn > 0) {
      for (let i = btnStart; i < btnEnd; i++) {
        var row: any = {};
        row.label = i + 1;
        row.start = i;
        this.pNumberList.push(row);
        this.lastPagination = i;
      }
    }
    let startFrom = startIndex * perPage;
    let endTo = startFrom + perPage;
    for (let i = startFrom; i < endTo; i++) {
      if (typeof airlineOffers[i] != 'undefined') {
        this.displayResults.push(airlineOffers[i]);
      }
    }
  }

  updateStart(i: any) {
    this.pSettings.start = i;
    this.getFilter();
  }

  triggerPagination(type: 'back' | 'next') {
    let startIndex = this.pSettings.start;
    if (type == 'back') {
      if (startIndex != 0) {
        startIndex = startIndex - 1;
      }
    } else {
      if (startIndex != this.lastPagination) {
        startIndex = startIndex + 1;
      }
    }
    this.pSettings.start = startIndex;
    this.getFilter();
  }

  convertTime(slideValue: number) {
    let slideValueToTime: any = (slideValue / 100).toFixed(2);
    slideValueToTime = slideValueToTime.toString();

    slideValueToTime = slideValueToTime.split('.');

    let hour = parseInt(slideValueToTime[0]);

    let min = slideValueToTime[1];

    if (typeof min === 'undefined') {
      min = '00';
    } else {
      min = parseInt(min);
      if (min === 60) {
        hour = hour + 1;
        min = '00';
      } else if (min > 60) {
        hour = hour + 1;
        min = min - 60;
      }
    }
    let hourToString: any = hour.toString();
    if (hourToString.length == 1) {
      hourToString = '0' + hourToString;
    }
    let minToString: any = min.toString();
    if (minToString.length == 1) {
      minToString = '0' + minToString;
    }
    return hourToString + ':' + minToString;
  }

  ngOnDestroy() {
    //  this.sandboxPageStateServiceSubscription.unsubscribe();
  }

  async searchFlightRequest() {
    this.formHaveInvalidFields = true;

    let patchSandboxSourceData: any = '';
    patchSandboxSourceData = { showError: 'No' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    let searchFlightFormValue = this.sandboxPageStateService.getSandboxPage().searchFlightFormValue;

    let cabinPreferenceCode = searchFlightFormValue.cabinPreferences;

    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.SEARCH_FLIGHTS_REQUEST_TEMPLATE);
    this.searchFlightsScreenRequest = JSON.parse(jsonRequestTemplate as any);

    this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.DataLists.PassengerList.Passenger = [];
    this.searchFlightsScreenRequest = JSON.parse(jsonRequestTemplate as any);
    this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.DataLists.PassengerList.Passenger = [];
    this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference.CabinPreferences.CabinType.Code = cabinPreferenceCode;

    let currentTimeStamp = new Date();
    let currentYear = currentTimeStamp.getFullYear();
    let currentMonth: any = currentTimeStamp.getMonth() + 1;
    currentMonth = currentMonth.toString().length === 1 ? '0' + currentMonth : currentMonth;
    let currentDate: any = currentTimeStamp.getDate();
    currentDate = currentDate.toString().length === 1 ? '0' + currentDate : currentDate;
    let adultYear = currentYear - 30;
    let youngAdultYear = currentYear - 15;
    let childYear = currentYear - 5;
    let infantYear = currentYear - 1;
    this.totPassenger = 1;

    this.addPassenger(searchFlightFormValue.adults, 'ADT', adultYear + '-' + currentMonth + '-' + currentDate);
    if (searchFlightFormValue.youngAdults != 0) {
      this.addPassenger(searchFlightFormValue.youngAdults, 'ADT', youngAdultYear + '-' + currentMonth + '-' + currentDate);
    }
    if (searchFlightFormValue.childs != 0) {
      this.addPassenger(searchFlightFormValue.childs, 'CHD', childYear + '-' + currentMonth + '-' + currentDate);
    }
    if (searchFlightFormValue.infants != 0) {
      this.addPassenger(searchFlightFormValue.infants, 'INF', infantYear + '-' + currentMonth + '-' + currentDate);
    }
    this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.CoreQuery.OriginDestinations.OriginDestination = [];
    if (!searchFlightFormValue.luggage) {
      this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Qualifier!.BaggagePricingQualifier!.BaggageOption = '1';
    } else {
      let baggageData = this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ;
      delete baggageData['Qualifier'];
    }

    let depatureDate = this.selectedDepartureDate;

    let destinationDetail = searchFlightFormValue.destination;

    this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.CoreQuery.OriginDestinations.OriginDestination;
    this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.CoreQuery.OriginDestinations.OriginDestination.push({
      Departure: { AirportCode: destinationDetail[0].depature, Date: depatureDate },
      Arrival: { AirportCode: destinationDetail[0].arrival }
    });

    if (searchFlightFormValue.haveReturn) {
      let returnDate = this.selectedArrivalDate;
      returnDate = returnDate === '' ? depatureDate : returnDate;

      let destinationDetail = searchFlightFormValue.destination;
      this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.CoreQuery.OriginDestinations.OriginDestination;
      this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.CoreQuery.OriginDestinations.OriginDestination.push({
        Departure: { AirportCode: destinationDetail[0].arrival, Date: returnDate },
        Arrival: { AirportCode: destinationDetail[0].depature }
      });
    }

    let flightPreferenceData = this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference;
    if (searchFlightFormValue.connections) {
      delete flightPreferenceData['FlightPreferences'];
    }
    this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference;

    if (searchFlightFormValue.farePreference) {
      let farePreferences = {} as any;
      let farePrefType: any[] = [];

      farePreferences = searchFlightFormValue.farePreference[0].item_id;

      farePrefType.push(farePreferences);
      if (searchFlightFormValue.fareRules) {
        farePreferences = '722';
        farePrefType.push(farePreferences);
      }

      this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference.FarePreferences!.Types.Type = farePrefType;
    } else {
      let farePreferences = this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference;
      delete farePreferences['FarePreferences'];
      this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference;
    }

    await this.apiService.getXMLResponse(this.sandboxPageStateService.SEARCH_FLIGHTS_SCREEN_URL, JSON.stringify(this.searchFlightsScreenRequest), this.inputParamsMap, {
      headers: new HttpHeaders({
        soapAction: 'AirShopping17_2_V1'
      }),
      responseType: 'text'
    });

    this.updateAirlineOffersScreenXML(this.sandboxPageStateService.SEARCH_FLIGHTS_SCREEN_URL);
  }

  updateAirlineOffersScreenXML(url: string) {
    let patchSandboxSourceData: any = '';

    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      if (this.formHaveInvalidFields === false) {
        patchSandboxSourceData = {
          showError: 'Yes',
          errorMessage: 'The remote server returned an error: (500) Internal Server Error.'
        };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      } else if (this.sandboxPageStateService.getErrorMessage() === 'Unable to process - system error NDC_AIRSHOPPING_9007 - Error getting priced availability.') {
        let errorMessage: any;
        if (typeof this.sandboxPageStateService.getErrorMessage() !== 'undefined') {
          errorMessage = 'There is no flight available for the given date or time';
          patchSandboxSourceData = { showError: 'Yes', errorMessage: errorMessage };
          this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
        }
      } else {
        patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      }
    } else {
      let airlineOffersScreen: AirlineOffersScreen = {} as AirlineOffersScreen;

      airlineOffersScreen.airlineOffers = [];
      airlineOffersScreen.airlineFilterData = {
        airportList: [],
        priceClassList: [],
        operaterList: []
      };
      let searchFlightScreenValue = this.sandboxPageStateService.getSandboxPage().searchFlightFormValue;
      let sliderDefaultValue: boundSlider[] = [
        {
          label: 'OutBound',
          startTime: 0,
          endTime: 2400
        },
        {
          label: 'InBound',
          startTime: 0,
          endTime: 2400
        }
      ];
      if (!searchFlightScreenValue.haveReturn) {
        sliderDefaultValue.splice(1, 1);
      }
      let filterOffersScreen: FilterOffersScreen = {
        airportList: [],
        priceClassList: [],
        operaterList: [],
        boundSliders: sliderDefaultValue
      };

      airlineOffersScreen.xml = this.sandboxPageStateService.getResponseFromMap(url);

      airlineOffersScreen.jsonData = this.xmlToJsonParserService.parseXMLToJSON(airlineOffersScreen.xml!);

      this.sandboxPageStateService.updateAirlineOffersScreenData(airlineOffersScreen);
      this.sandboxPageStateService.updateFilterOffersScreenData(filterOffersScreen);

      patchSandboxSourceData = { mainMenu: 'none', sandboxScreen: 'search-flights-screen' };

      let resfreshSearchFilterScreen = true;
      this.sandboxPageStateService.updateisSearchFliterRefresh(resfreshSearchFilterScreen);

      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  addPassenger(passengerCount: number, type: 'ADT' | 'CHD' | 'INF', dob: any) {
    for (let i = 1; i <= passengerCount; i++) {
      let passenger = this.getDefaultPassenger();
      passenger.$.PassengerID = 'SH' + this.totPassenger;
      passenger.PTC = type;
      passenger.Birthdate = dob;
      this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.DataLists.PassengerList.Passenger.push(passenger);
      this.totPassenger++;
    }
  }
  getDefaultCabinPreference(): CabinPreferences {
    const cabinPreference: CabinPreferences = {} as CabinPreferences;
    cabinPreference.CabinType.Code = this.inputParamsMap.get('##CabinType##Code##');
    return cabinPreference;
  }

  getDefaultPassenger(): searchFlightPassengers {
    const passenger: searchFlightPassengers = {} as searchFlightPassengers;
    passenger.$ = { PassengerID: this.inputParamsMap.get('##Passenger##PassengerID##') };
    passenger.PTC = this.inputParamsMap.get('##Passenger##PTC##');
    passenger.Birthdate = this.inputParamsMap.get('##Passenger##Birthdate##');
    passenger.ResidenceCountryCode = this.inputParamsMap.get('##Passenger##ResidenceCountryCode##');
    passenger.CitizenshipCountryCode = this.inputParamsMap.get('##Passenger##CitizenshipCountryCode##');
    return passenger;
  }

  triggerSearchFlightRequest(offerItem: any, i: number) {
    if (offerItem.fromDate) {
      this.selectedDepartureDate = offerItem.fromDate;
    }
    if (offerItem.toDate) {
      this.selectedArrivalDate = offerItem.toDate;
    }
    this.searchFlightRequest();

    let additionalOffersData = this.sandboxPageStateService.getAddionalOffersData();

    additionalOffersData[0].seletcedItemIndex = i;
    this.sandboxPageStateService.updateAddionalOffersData(additionalOffersData);
  }
}
